const STORAGE_KEY = 'deallock-workspace-dataset-v6';
function seedWorkspaceDataset() {
    return {
        projects: [
            {
                id: 'tower-a',
                name: 'Tower A',
                summary: 'High-priority mixed-use project with active broker coordination and live OSI handoff links.',
                agentIds: [
                    'jane-smith',
                    'mike-johnson',
                    'sarah-lee',
                    'david-kim',
                    'emma-wilson',
                    'tom-brown',
                    'ava-clark',
                    'liam-hall',
                    'mia-turner',
                    'oliver-scott',
                ],
                status: 'ongoing',
            },
            {
                id: 'harbor-point',
                name: 'Harbor Point',
                summary: 'Waterfront office conversion project with active lead routing and broker follow-up.',
                agentIds: ['jane-smith', 'noah-davis'],
                status: 'ongoing',
            },
            {
                id: 'atrium-west',
                name: 'Atrium West',
                summary: 'Urban office portfolio requiring high-touch coordination between leads and assigned agents.',
                agentIds: ['jane-smith', 'grace-evans'],
                status: 'ongoing',
            },
            {
                id: 'tower-c',
                name: 'Tower C',
                summary: 'Secondary tower project available for new agent assignments and qualification.',
                agentIds: ['chloe-martin'],
                status: 'ongoing',
            },
            {
                id: 'park-view',
                name: 'Park View',
                summary: 'Residential project currently open for matching and agent reassignment.',
                agentIds: ['lucas-green'],
                status: 'completed',
            },
            {
                id: 'skyline-one',
                name: 'Skyline One',
                summary: 'High-visibility listing with active landing page and lead-generation support.',
                agentIds: ['zoe-carter'],
                status: 'completed',
            },
            {
                id: 'residential-tower-d',
                name: 'Residential Tower D',
                summary: 'Premium residential tower currently in pre-leasing phase.',
                agentIds: ['jane-smith', 'mike-johnson'],
                status: 'ongoing',
            },
            {
                id: 'shopping-complex-e',
                name: 'Shopping Complex E',
                summary: 'Mixed retail anchor with active broker outreach.',
                agentIds: ['jane-smith', 'sarah-lee'],
                status: 'ongoing',
            },
            {
                id: 'mixed-use-f',
                name: 'Mixed-Use Development F',
                summary: 'Large mixed-use property combining retail, office, and residential floors.',
                agentIds: ['jane-smith', 'david-kim', 'emma-wilson'],
                status: 'ongoing',
            },
            {
                id: 'office-park-g',
                name: 'Office Park G',
                summary: 'Suburban office park with rolling lease renewals.',
                agentIds: ['jane-smith'],
                status: 'ongoing',
            },
            {
                id: 'industrial-h',
                name: 'Industrial Block H',
                summary: 'Logistics-focused industrial block near port access.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'plaza-i',
                name: 'Plaza I',
                summary: 'Downtown plaza with high foot traffic, currently re-tenanting.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'lakeside-j',
                name: 'Lakeside J',
                summary: 'Lakeside residential development; pre-launch marketing in progress.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'gateway-k',
                name: 'Gateway K',
                summary: 'Transit-adjacent retail; lease pipeline being qualified.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'studio-loft-l',
                name: 'Studio Loft L',
                summary: 'Boutique loft conversion targeting creative-industry tenants.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'tower-m',
                name: 'Tower M',
                summary: 'New tower with full-floor tenant offerings; demand sounding underway.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'campus-n',
                name: 'Campus N',
                summary: 'Multi-building corporate campus, expansion phase pending agent coverage.',
                agentIds: [],
                status: 'ongoing',
            },
            {
                id: 'gallery-o',
                name: 'Gallery O',
                summary: 'Heritage retail gallery; renewal cycle starting.',
                agentIds: [],
                status: 'completed',
            },
            {
                id: 'commons-p',
                name: 'The Commons P',
                summary: 'Mixed-use community development, leasing fully completed.',
                agentIds: [],
                status: 'completed',
            },
            {
                id: 'heights-q',
                name: 'Heights Q',
                summary: 'Hillside residential phase one; sale records archived.',
                agentIds: [],
                status: 'completed',
            },
        ],
        agents: [
            {
                id: 'jane-smith',
                name: 'Jane Smith',
                summary: 'Top-performing IPC agent with active assignments across Brookfield and Harbor Point.',
                projectIds: ['tower-a', 'harbor-point', 'atrium-west'],
                email: 'jane.smith@example.com',
                phone: '+82-10-2222-3333',
                status: 'active',
            },
            {
                id: 'mike-johnson',
                name: 'Mike Johnson',
                summary: 'Senior broker support specialist focused on high-priority commercial accounts.',
                projectIds: ['tower-a'],
                email: 'mike.johnson@example.com',
                phone: '+82-10-2222-3334',
                status: 'active',
            },
            {
                id: 'sarah-lee',
                name: 'Sarah Lee',
                summary: 'Agent focused on client handoff quality and quick project turnaround.',
                projectIds: ['tower-a'],
                email: 'sarah.lee@example.com',
                phone: '+82-10-2222-3335',
                status: 'active',
            },
            {
                id: 'david-kim',
                name: 'David Kim',
                summary: 'Operations-focused agent supporting active commercial listings.',
                projectIds: ['tower-a'],
                email: 'david.kim@example.com',
                phone: '+82-10-2222-3336',
                status: 'active',
            },
            {
                id: 'emma-wilson',
                name: 'Emma Wilson',
                summary: 'Lead-response specialist helping keep active projects warm and qualified.',
                projectIds: ['tower-a'],
                email: 'emma.wilson@example.com',
                phone: '+82-10-2222-3337',
                status: 'active',
            },
            {
                id: 'tom-brown',
                name: 'Tom Brown',
                summary: 'Agent handling broker coordination and follow-up for assigned deals.',
                projectIds: ['tower-a'],
                email: 'tom.brown@example.com',
                phone: '+82-10-2222-3338',
                status: 'inactive',
            },
            {
                id: 'ava-clark',
                name: 'Ava Clark',
                summary: 'Relationship manager supporting new and existing commercial opportunities.',
                projectIds: ['tower-a'],
                email: 'ava.clark@example.com',
                phone: '+82-10-2222-3339',
                status: 'active',
            },
            {
                id: 'liam-hall',
                name: 'Liam Hall',
                summary: 'Agent focused on qualification and early-stage commercial outreach.',
                projectIds: ['tower-a'],
                email: 'liam.hall@example.com',
                phone: '+82-10-2222-3340',
                status: 'active',
            },
            {
                id: 'mia-turner',
                name: 'Mia Turner',
                summary: 'Project-assignment specialist supporting active internal handoffs.',
                projectIds: ['tower-a'],
                email: 'mia.turner@example.com',
                phone: '+82-10-2222-3341',
                status: 'inactive',
            },
            {
                id: 'oliver-scott',
                name: 'Oliver Scott',
                summary: 'Agent focused on keeping active listings staffed and responsive.',
                projectIds: ['tower-a'],
                email: 'oliver.scott@example.com',
                phone: '+82-10-2222-3342',
                status: 'active',
            },
            {
                id: 'noah-davis',
                name: 'Noah Davis',
                summary: 'Commercial leasing specialist supporting Harbor Point.',
                projectIds: ['harbor-point'],
                email: 'noah.davis@example.com',
                phone: '+82-10-2222-3343',
                status: 'active',
            },
            {
                id: 'sophia-young',
                name: 'Sophia Young',
                summary: 'Agent available for reassignment across open commercial opportunities.',
                projectIds: [],
                email: 'sophia.young@example.com',
                status: 'invited',
            },
            {
                id: 'ethan-walker',
                name: 'Ethan Walker',
                summary: 'Broker partner focused on newly qualified inbound leads.',
                projectIds: [],
                email: 'ethan.walker@example.com',
                status: 'invited',
            },
            {
                id: 'chloe-martin',
                name: 'Chloe Martin',
                summary: 'Project support lead currently assigned to Tower C.',
                projectIds: ['tower-c'],
                email: 'chloe.martin@example.com',
                phone: '+82-10-2222-3346',
                status: 'active',
            },
            {
                id: 'mason-adams',
                name: 'Mason Adams',
                summary: 'Agent ready for new assignments and commercial follow-up.',
                projectIds: [],
                email: 'mason.adams@example.com',
                status: 'invited',
            },
            {
                id: 'lily-roberts',
                name: 'Lily Roberts',
                summary: 'Campaign and outreach coordinator available for new project coverage.',
                projectIds: [],
                email: 'lily.roberts@example.com',
                phone: '+82-10-2222-3348',
                status: 'inactive',
            },
            {
                id: 'jacob-morris',
                name: 'Jacob Morris',
                summary: 'Broker liaison available for active project staffing.',
                projectIds: [],
                email: 'jacob.morris@example.com',
                status: 'invited',
            },
            {
                id: 'grace-evans',
                name: 'Grace Evans',
                summary: 'Atrium West specialist with availability for adjacent accounts.',
                projectIds: ['atrium-west'],
                email: 'grace.evans@example.com',
                phone: '+82-10-2222-3350',
                status: 'active',
            },
            {
                id: 'lucas-green',
                name: 'Lucas Green',
                summary: 'Residential/commercial crossover agent supporting Park View.',
                projectIds: ['park-view'],
                email: 'lucas.green@example.com',
                phone: '+82-10-2222-3351',
                status: 'active',
            },
            {
                id: 'zoe-carter',
                name: 'Zoe Carter',
                summary: 'Marketing-aligned agent supporting Skyline One.',
                projectIds: ['skyline-one'],
                email: 'zoe.carter@example.com',
                phone: '+82-10-2222-3352',
                status: 'active',
            },
        ],
        leads: [
            {
                id: 'brookfield-capital',
                name: 'Brookfield Capital',
                company: 'Brookfield',
                summary: 'High-intent lead already mapped to flagship projects and active follow-up.',
                projectIds: ['tower-a', 'harbor-point'],
            },
            {
                id: 'northern-realty',
                name: 'Northern Realty',
                company: 'Northern Realty',
                summary: 'Warm lead with one active match and several near-fit projects still open.',
                projectIds: ['tower-c'],
            },
            {
                id: 'urban-ventures',
                name: 'Urban Ventures',
                company: 'Urban Ventures',
                summary: 'Early-stage lead that still needs tighter project matching and qualification.',
                projectIds: ['atrium-west'],
            },
        ],
    };
}
function isBrowser() {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}
export function readWorkspaceDataset() {
    if (!isBrowser()) {
        return seedWorkspaceDataset();
    }
    try {
        const rawValue = window.localStorage.getItem(STORAGE_KEY);
        if (!rawValue) {
            return seedWorkspaceDataset();
        }
        const parsed = JSON.parse(rawValue);
        if (!Array.isArray(parsed.projects) || !Array.isArray(parsed.agents) || !Array.isArray(parsed.leads)) {
            return seedWorkspaceDataset();
        }
        return {
            projects: parsed.projects,
            agents: parsed.agents,
            leads: parsed.leads,
        };
    }
    catch {
        return seedWorkspaceDataset();
    }
}
export function writeWorkspaceDataset(nextDataset) {
    if (!isBrowser()) {
        return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextDataset));
}
